import { map } from "./_math_utils";

export default class ParallaxImage {
  targetElement: HTMLElement;

  triggerElement: HTMLElement;

  farRatio: number;

  previousY: number | null = null;

  constructor(targetElement: HTMLElement, triggerElement: HTMLElement, farRatio: number) {
    this.targetElement = targetElement;
    this.triggerElement = triggerElement;
    this.farRatio = farRatio;
  }

  update() {
    const scrollYPx = window.pageYOffset;
    const triggerHeightPx = this.triggerElement.offsetHeight;
    const viewHeightPx = window.innerHeight;
    const triggerTopPx = this.triggerElement.getBoundingClientRect().top + scrollYPx;
    const triggerBottomPx = triggerTopPx + triggerHeightPx;
    const beginYPx = triggerTopPx - viewHeightPx;
    const endYPx = triggerBottomPx;
    const fromY = (triggerHeightPx + viewHeightPx) / 2 * this.farRatio * -1;
    const toY = fromY * -1;
    // console.log(beginYPx, endYPx, scrollYPx);
    const y = map(scrollYPx, beginYPx, endYPx, fromY, toY, true);
    if (this.previousY !== y) {
      this.targetElement.style.transform = `translate(0,${y}px)`;

    }
    this.previousY = y;
  }
}